export enum MeritBenchmarkVisibilityType {
  Internal = 'Internal',
  External = 'External',
  None = 'None',
  Both = 'Both'
}
